import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpParams,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError, finalize, shareReplay, switchMap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthRefreshInterceptorService implements HttpInterceptor {
  private restoration?: Observable<any>;
  constructor(private authService: AuthService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const endpoint = request.url.split('?')[0];
    if (endpoint === environment.apiUrl + '/auth' || endpoint === environment.apiUrl + '/restore') {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 401) {
          return throwError(error);
        }

        if (!this.restoration) {
          this.restoration = this.authService.refreshAccessToken().pipe(
            catchError((refreshError) => {
              const rememberedLogin = this.authService.autoLogin();
              return rememberedLogin || throwError(refreshError);
            }),
            catchError((restoreError) => {
              this.authService.clearAuthenticationState();
              return throwError(restoreError);
            }),
            finalize(() => { this.restoration = undefined; }),
            shareReplay(1)
          );
        }

        return this.restoration.pipe(
          switchMap(() => next.handle(this.addAuthenticationToken(request)))
        );
      })
    );

    /*
    return this.authService.user.pipe(
      take(1),
      exhaustMap((user) => {
        if (!user) {
          return next.handle(req);
        }
        const modifiedReq = req.clone({
           headers: new HttpHeaders().set('Authorization', 'Bearer ' + user.token),
        });
        return next.handle(modifiedReq).pipe( tap(() => {},
        (err: any) => {
        if (err instanceof HttpErrorResponse) {
         if (err.status !== 401) {
           return;
          }
          // get a new token

          if (this.refreshTokenInProgress) {
            // If refreshTokenInProgress is true, we will wait until refreshTokenSubject has a non-null value
            // – which means the new token is ready and we can retry the request again
            return this.refreshTokenSubject
                .filter(result => result !== null)
                .take(1)
                .switchMap(() => next.handle(this.addAuthenticationToken(request)));
        } else {
            this.refreshTokenInProgress = true;

            // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
            this.refreshTokenSubject.next(null);

            // Call auth.refreshAccessToken(this is an Observable that will be returned)
            return this.auth
                .refreshAccessToken()
                .switchMap((token: any) => {
                    //When the call to refreshToken completes we reset the refreshTokenInProgress to false
                    // for the next time the token needs to be refreshed
                    this.refreshTokenInProgress = false;
                    this.refreshTokenSubject.next(token);

                    return next.handle(this.addAuthenticationToken(request));
                })
                .catch((err: any) => {
                    this.refreshTokenInProgress = false;

                    this.authService.logout();
                    return Observable.throw(error);
                });
        }

          // end get a new token


          //this.router.navigate(['login']);
        }
      }));
      })
    );*/
  }

  addAuthenticationToken(request: any) {
    // Get access token from Local Storage
    const accessToken = this.authService.getAccessToken();

    // If access token is null this means that user is not logged in
    // And we return the original request
    if (!accessToken) {
      return request;
    }

    // We clone the request, because the original request is immutable
    return request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + accessToken,
      },
    });
  }
}
